import React from 'react'
import PropTypes from 'prop-types'
import { View } from '@olxbr/design-system'

const MailShieldIcon = props => (
  <View>
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.1"
        d="M48.1151 87.3105C69.7621 87.3105 87.3105 69.7621 87.3105 48.1151C87.3105 26.468 69.7621 8.91956 48.1151 8.91956C26.468 8.91956 8.91956 26.468 8.91956 48.1151C8.91956 69.7621 26.468 87.3105 48.1151 87.3105Z"
        fill="#6E0AD6"
      />
      <path
        d="M12.0587 24.6543L64.6549 17.2624C68.2709 16.7542 71.6453 19.2969 72.1535 22.9129L77.6974 62.3601C78.2056 65.9761 75.6628 69.3504 72.0469 69.8586L19.4506 77.2505C15.8346 77.7587 12.4603 75.216 11.9521 71.6L6.40818 32.1528C5.89999 28.5368 8.44273 25.1625 12.0587 24.6543Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1656 25.6666C9.08684 26.0993 6.8832 28.8789 7.11251 31.9382L42.3902 49.9069L71.348 22.9108C70.7253 19.9067 67.8408 17.842 64.7619 18.2747L12.1656 25.6666ZM12.6974 71.7652L7.35389 33.7445L42.1772 51.4818C42.4581 51.6248 42.7985 51.577 43.029 51.362L71.6254 24.703L74.8224 46.0459C74.8838 46.4555 75.2656 46.7379 75.6753 46.6765C76.0849 46.6152 76.3672 46.2333 76.3059 45.8237L72.9011 23.0944C72.8995 23.0809 72.8976 23.0675 72.8953 23.0541C72.3179 19.0407 68.5712 16.2246 64.5531 16.7893L11.9569 24.1812C7.9307 24.7471 5.10218 28.5007 5.66802 32.5268L11.212 71.974C11.7778 76.0002 15.5314 78.8287 19.5576 78.2628L19.5593 78.2626L59.1061 72.6121C59.5161 72.5535 59.801 72.1736 59.7424 71.7635C59.6838 71.3535 59.3039 71.0686 58.8939 71.1272L19.3488 76.7774C16.143 77.228 13.1479 74.971 12.6974 71.7652ZM16.947 71.7634C16.709 72.1024 16.7909 72.5702 17.1299 72.8082C17.4689 73.0462 17.9367 72.9643 18.1747 72.6253L21.1437 68.3964C21.3817 68.0574 21.2999 67.5897 20.9609 67.3517C20.6219 67.1137 20.1541 67.1955 19.9161 67.5345L16.947 71.7634ZM21.969 64.6106C21.731 64.9496 21.8128 65.4173 22.1519 65.6553C22.4909 65.8934 22.9586 65.8115 23.1966 65.4725L32.5279 52.1818C32.7659 51.8428 32.6841 51.375 32.3451 51.137C32.0061 50.899 31.5383 50.9809 31.3003 51.3199L21.969 64.6106Z"
        fill="#4A4A4A"
      />
      <path
        d="M75.7259 49.9387C75.7259 49.9387 69.091 56.7795 62.8143 57.6617L64.879 72.3532C65.3056 75.3881 66.9349 77.9726 69.296 79.2585C71.6572 80.5444 78.8205 83.9689 79.1158 84.0681L80.6213 84.7709L81.8747 83.6803C82.1215 83.4346 88.0731 78.2373 90.0477 76.2717C91.9036 74.4635 92.8264 71.5203 92.3902 68.4164L90.3351 53.7939C83.9894 54.6857 75.7259 49.9387 75.7259 49.9387Z"
        fill="#6E0AD6"
        stroke="#4A4A4A"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72.4062 67.3565L77.6672 71.2594L84.0696 62.7632"
        stroke="white"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </View>
)

MailShieldIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
}

MailShieldIcon.defaultProps = {
  width: 96,
  height: 96,
}

export default MailShieldIcon
